import { fabricApi } from "../imports";
import _ from "lodash";

export function getDimensions(product) {
  let regex = /([0-9]|\.)+/gm;
  // TODO revisit
  // const sku = product.variants[0].sku;
  // if (sku.split("-")[1] == "COL") {
  //   return product.handle.split("-")[2].match(regex);
  // } else {
  //   return sku.split("-")[2].match(regex);
  // }
  return product.title.match(regex);
  // [height, width]
}

export function titleForProduct(product) {
  let canvasDimensions = getDimensions(product);

  return canvasDimensions
    ? `${canvasDimensions[0]}" x ${canvasDimensions[1]}"`
    : product.title;
}

export function priceForProduct(product) {
  let price = product.variants[0].price;
  return price == 0.0 ? "FREE*" : "$" + price;
}

export function isArtwork(product) {
  return product.variants[0].sku.includes("CP-ART");
}

export function getHandle() {
  const urlParams = new URLSearchParams(window.location.search);
  let handle;
  if (window.collectionName == "collage-prints") {
    handle = window.product.handle.split("-").slice(0, -1).join("-");
  }
  handle ||= urlParams.get("handle") || window.handle;
  return handle;
}

export function getCollection(currentItem = null) {
  const urlParams = new URLSearchParams(window.location.search);
  let collection = urlParams.get("collection");
  let sku = window?.product?.variants?.[0]?.sku;

  // The collection is determined based on the URL we're on, but this
  // logic breaks down on the cart, as there are no clues in the url.
  // On a related note, we should be getting our data from the state rather
  // than the URL.
  if (collection === null && sku === undefined && currentItem !== null) {
    sku = currentItem.sku;
  }

  if (window.collectionName !== undefined) {
    collection = window.collectionName;
  }

  // TODO: Update collections for every SKU
  // If an sku is present, it overrides general collection names
  if (sku) {
    switch (sku !== undefined) {
      case sku.includes("CP-WALL"):
        collection = "wall-display-prints";
        break;
      case sku.includes("CP-COL"):
        collection = "collage-prints";
        break;
      case sku.includes("CP-TRIP-CLFL"): // classic flow
      case sku.includes("CP-TRIP-CZFL"): // cozy flow
        collection = "triptych-flow-prints";
        break;
      case sku.includes("CP-TRIP-CLAS"): // classic
      case sku.includes("CP-TRIP-COZ"): // cozy
        collection = "triptych-prints";
        break;
    }
  }

  // If you're debugging and your collection is single-canvas-featured-products,
  // it's because we set that as the default when we do not know the collection
  if (collection === undefined || collection === null) {
    collection = "single-canvas-featured-products";
  }

  return collection;
}

export function generateNewPlayerState({
  canWidth: canWidthInches,
  canHeight: canHeightInches,
  imageHeightOriginal,
  imageWidthOriginal,
}) {
  if (
    [
      canWidthInches,
      canHeightInches,
      imageHeightOriginal,
      imageWidthOriginal,
    ].includes(0)
  ) {
    return { data: {} };
  }
  const cnH = canHeightInches * 96;
  const cnW = canWidthInches * 96;
  let heightRatio = cnH / imageHeightOriginal;
  let widthRatio = cnW / imageWidthOriginal;
  let ratio = heightRatio > widthRatio ? heightRatio : widthRatio;
  let imgH = imageHeightOriginal * ratio;
  let imgW = imageWidthOriginal * ratio;
  return {
    data: {
      imageMagickObj: {
        verticalPos: cnH / 2,
        horizontalPos: cnW / 2,
        imageHeight: imgH,
        imageWidth: imgW,
        verticalMov: 0,
        horizontalMov: 0,
        canWidth: cnW,
        canHeight: cnH,
        rotate: 0,
        blacknwhite: false,
      },
      finalObj: {
        canHeight: cnH,
        canWidth: cnW,
        reduceRatio: 1,
        sizeRatio: ratio,
        ratio: 1,
      },
    },
  };
}

export function generateNewMultiPlayerState({
  canWidth: canWidthInches,
  canHeight: canHeightInches,
  imageHeightOriginal,
  imageWidthOriginal,
  node,
}) {
  if (
    [
      canWidthInches,
      canHeightInches,
      imageHeightOriginal,
      imageWidthOriginal,
    ].includes(0)
  ) {
    return { data: {} };
  }
  const cnH = canHeightInches * 96;
  const cnW = canWidthInches * 96;
  let heightRatio = cnH / imageHeightOriginal;
  let widthRatio = cnW / imageWidthOriginal;
  let ratio = heightRatio > widthRatio ? heightRatio : widthRatio;
  let imgH = imageHeightOriginal * ratio;
  let imgW = imageWidthOriginal * ratio;

  return {
    obj: {
      canHeight: cnH,
      canWidth: cnW,
      reduceRatio: 1,
      sizeRatio: ratio,
      ratio: 1,
      verticalPos: cnH / 2,
      horizontalPos: cnW / 2,
      imageHeight: imgH,
      imageWidth: imgW,
      verticalMov: 0,
      horizontalMov: 0,
      rotate: 0,
      blacknwhite: false,
    },
    node: node,
  };
}

export function isSingleCanvas(collectionName) {
  return collectionName === "single-canvas-featured-products";
}

// Products that the size selector does not need to load for
export function dontLoadSizeSelector(collectionName) {
  const collections = [
    "wall-display-prints",
    "mug-prints",
    "camping-mug-prints",
    "tumbler-prints",
    "tote-prints",
    "tote-prints-large",
    "tote-prints-small",
    "crewneck-sweatshirt",
    "crewneck-youth-sweatshirt",
    "hoodie-sweatshirt",
    "hoodie-youth-sweatshirt",
    "polo-shirt",
    "polo-youth-shirt",
    "polo-womens-shirt",
    "tshirt-prints",
    "tshirt-womens",
    "tshirt-youth",
    "photos-prints",
    "bottle-opener",
    "wood",
    "pulp-square-coaster",
    "pulp-round-coaster",
    "koozie-16",
    "koozie-12",
    "water-bottle",
    "drink-tumbler",
    "bottle-opener-poly",
    "bottle-opener-brushed",
    "luggage-tag",
    "dog-tag",
    "triptych-prints",
    "triptych-flow-prints",
  ];
  return _.includes(collections, collectionName);
}

// If product has a recommended size for the size selector
export function hasRecommendedSize(collectionName) {
  const collections = ["poster-prints", "pillow-prints"];
  return _.includes(collections, collectionName);
}

// If product is apparel
export function isApparel(productType) {
  return [
    "tshirt",
    "tshirt-youth",
    "tshirt-womens",
    "crewneck",
    "crewneck-youth",
    "hoodie",
    "hoodie-youth",
    "polo",
    "polo-womens",
    "polo-youth",
  ].includes(productType);
}

// If product has front and back prints
export function hasFrontAndBack(productType) {
  return [
    "tshirt",
    "tshirt-youth",
    "tshirt-womens",
    "crewneck",
    "crewneck-youth",
    "hoodie",
    "hoodie-youth",
  ].includes(productType);
}

/**
 * If a product uses an image for a mask instead of a
 * fabric shape/path
 */
export function usesImageMask(productType) {
  return [
    "bottle",
    "dog-tag",
    "bottle-opener-brushed",
    "koozie-16",
    "koozie-12",
  ].includes(productType);
}
/**
 * Filters cart for PURL items
 * @param {Array} items Current cart items
 * @returns {Array}
 */
export function filterItemsForPurl(items) {
  return items?.filter(
    (item) =>
      item.properties?._purl && item.properties?._purl !== "" && item.price == 0
  );
}

/**
 * Check if a purl code is vaild
 * @param {String} purl Purl code
 * @returns
 */
export const purlIsValid = async (purl = null) => {
  const queryParams = new URLSearchParams(window.location.search);
  const currentPurl =
    purl || queryParams.get("purl") || localStorage.getItem("purl") || null;

  // Check api to see if current purl is valid
  if (currentPurl) {
    return await fabricApi.checkPurlCode(currentPurl);
  }
  return true;
};
